export const APPROVE_DS_ERROR = "APPROVE_DS_ERROR",
  APPROVE_DS_BEGIN = "APPROVE_DS_BEGIN",
  APPROVE_DS_SUCCESS = "APPROVE_DS_SUCCESS",
  SET_CURRENT_DS_APPLICATION = "SET_CURRENT_DS_APPLICATION",
  EMAIL_ERROR = "EMAIL_ERROR",
  EMAIL_BEGIN = "EMAIL_BEGIN",
  EMAIL_SUCCESS = "EMAIL_SUCCESS";
